import React, { useState, useContext } from 'react';
import { Authentication } from '../../App'
import axios from "axios";
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import Card from '@mui/material/Card';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import Dropzone from 'react-dropzone';
import Button from '@mui/material/Button';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  // boxShadow: 24,
  p: 6,
};
const closeButtonStyle = {
  height: 0,
  textAlign: "right",
};

function NewTrainingModal(props) {
  const authentication = useContext(Authentication);
  const [kubun, setkubun] = useState(1);
  const [categorys, setcategorys] = useState();
  const [Date, setDate] = useState();
  const [category, setcategory] = useState();
  const [title, settitle] = useState();
  const [syusai, setsyusai] = useState();
  const [suisyou, setsuisyou] = useState();
  const [teiin, setteiin] = useState();
  const [basyo, setbasyo] = useState();
  const [jikan, setjikan] = useState();
  const [kingaku, setkingaku] = useState();
  const [teika, setteika] = useState();
  const [no, setno] = useState();
  const [file, setfile] = useState();
  const [fileName, setfileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [userName, setuserName] = useState("");
  const [CheckBoxRental, setCheckBoxRental] = useState(false);
  const [userId, setuserId] = useState();
  const [Url, setUrl] = useState();

  const onkubun = (value) => {
    setLoading(true);

    setkubun(value);
    setTimeout(() => {
      setcategory();
      setDate();
      settitle();
      setsyusai();
      setsuisyou();
      setteiin();
      setbasyo();
      setjikan();
      setkingaku();
      setteika();
      setno();
      setfile();
      setUrl();
      setfileName();
      setLoading(false)
      setCheckBoxRental(false);
    }, 1)
  }

  React.useEffect(() => {
    let url = "https://orooms.global-center.co.jp/v1/recruiting/user";

    axios.get(url, { headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } }).then((response) => {

      setuserName(response.data.user_name_all)

      // setuserSection(response.data.Tenpo_Name)

    });

  }, []);
  const insertData = () => {

    if (kubun == 4 && !file) {
      alert("画像が添付されていません");
      return;
    }
    if (!category) {
      alert("カテゴリが選択されていません")
      return;
    }
    setLoading(true);

    // let url = `http://localhost:5000/v1/training/events/insert`;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/training/events/insert`;

    axios.post(url, {
      training_division: kubun,
      training_events_category_id: category,
      training_day: Date,
      training_time: jikan,
      title: title,
      promoter: syusai,
      recommended_section: suisyou,
      capacity: teiin,
      place: basyo,
      training_amount: kingaku,
      training_full_price: teika,
      course_number: no,
      is_rental: CheckBoxRental,
      url:Url
    }).then((abc) => {

      if (file) {
        // let url2 = `http://localhost:5000/v1/training/events/upload_book/` + abc.data.id + "/" + userId;
        let url2 = process.env.REACT_APP_API_BASE_URL + `/v1/training/events/upload_book/` + abc.data.id + "/" + userId;

        const token = authentication.getAccessToken();
        var formData = new FormData();
        formData.append("files", file[0]);
        fetch(url2, {
          method: 'post',
          body: formData,
          headers: { 'Authorization': 'Bearer ' + token },
        })
          .then(() => {
            setfile();
            setfileName();
            alert("登録しました");
            setLoading(false)
          });
      }else{
        alert("登録しました");
        setLoading(false)
      }
    });
  }

  const onDrop = (files) => {
    console.log(files);

    if (files[0].type.match(/image/)) {
      setfile(files);
      setfileName(files[0].name);


    } else {
      alert("画像ファイルを選択してください")
    }
  }

  const check = (data) => {
    setCheckBoxRental(data.checked);
  }


  React.useEffect(() => {
    // let url = `http://localhost:5000/v1/users/detail`;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/users/detail`;

    axios.get(url, { headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } }).then((response) => {
      setuserId(response.data.id)
    });
  }, []);

  React.useEffect(() => {
    // let category = `http://localhost:5000/v1/training/events/categorys/list`;
    let category = process.env.REACT_APP_API_BASE_URL + `/v1/training/events/categorys/list`;

    axios.get(category).then((abc) => {
      setcategorys(abc.data)
    });
  }, []);
  if (!categorys) return null;

  return (
    <Modal
      open={props.open}
      onClose={() => props.setOpen(false)}
    >
      <Box sx={style}>
        <Box sx={closeButtonStyle}>
          <IconButton onClick={() => props.setOpen(false)}>
            <CloseIcon fontSize={'large'} />
          </IconButton>
        </Box>
        <Typography sx={{ fontSize: 28, fontWeight: 'bold', mb: 2, marginLeft: 40 }} gutterBottom>新規登録</Typography>
        <Box>
          <table style={{ margin: "auto", height: 600 }} width="65%" border="0">
            <tbody>
              {loading == false ?
                <tr>
                  <th>区分</th>
                  <td>
                    <FormControl style={{ margin: "10px 0 10px 20px", textAlign: "left" }}>
                      {/* <FormLabel id="demo-row-radio-buttons-group-label">区分</FormLabel> */}

                      <RadioGroup
                        row
                        aria-labelledby="category"
                        name="row-radio-buttons-group"
                        defaultValue={kubun}
                        onChange={(e) => { onkubun(e.target.value) }}
                      >
                        <FormControlLabel value={1} control={<Radio size="small" />} label="社内" />
                        <FormControlLabel value={2} control={<Radio size="small" />} label="社外" />
                        <FormControlLabel value={3} control={<Radio size="small" />} label="通信講座" />
                        <FormControlLabel value={4} control={<Radio size="small" />} label="推薦図書" />
                      </RadioGroup>
                    </FormControl>
                  </td>
                </tr> : ""}
              {loading == false ?
                <tr>
                  {kubun != 4 ? <th>日程</th> : ""}
                  {kubun != 4 ? <td>
                    <TextField
                      style={{ width: 400 }}
                      type="date"
                      onChange={(e) => { setDate(e.target.value) }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </td> : ""}
                  <th>カテゴリ</th>
                  <td>
                    <FormControl>
                      <Select
                        style={{ width: 400 }}
                        labelId="From-select-label"
                        id="From-select"
                        label="From"
                        onChange={(e) => { setcategory(e.target.value) }}
                      >
                        {categorys.map(function (i) {
                          return <MenuItem value={i.id}>{i.category_title}</MenuItem>
                        }, this)}
                      </Select>
                    </FormControl>
                  </td>
                </tr> : ""}

              {loading == false ?
                <tr>
                  <th>タイトル</th>
                  <td>
                    <TextField onChange={(e) => { settitle(e.target.value) }} style={{ width: 400 }} id="outlined-basic" variant="outlined" />
                  </td>
                  {kubun != 4 ? <th>主催者</th> : ""}
                  {kubun != 4 ? <td>
                    <TextField onChange={(e) => { setsyusai(e.target.value) }} style={{ width: 400 }} id="outlined-basic" variant="outlined" />
                  </td> : ""}
                </tr> : ""}

              {loading == false ?
                <tr>
                  <th>参加推奨部門・階層</th>
                  <td>
                    <TextField onChange={(e) => { setsuisyou(e.target.value) }} style={{ width: 400 }} id="outlined-basic" variant="outlined" />
                  </td>
                  {kubun != 4 ? <th>定員</th> : ""}
                  {kubun != 4 ? <td>
                    <TextField onChange={(e) => { setteiin(e.target.value) }} style={{ width: 400 }} id="outlined-basic" variant="outlined" />
                  </td> : ""}
                </tr> : ""}


              {loading == false ?
                kubun != 4 ? <tr>
                  <th>場所</th>
                  <td>
                    <TextField onChange={(e) => { setbasyo(e.target.value) }} style={{ width: 400 }} id="outlined-basic" variant="outlined" />
                  </td>
                  <th>時間</th>
                  <td>
                    <TextField onChange={(e) => { setjikan(e.target.value) }} style={{ width: 400 }} id="outlined-basic" variant="outlined" />
                  </td>
                </tr> : "" : ""}

              {loading == false ?
                <tr>
                  {kubun != 4 && kubun != 1 ? <th>金額(1名)</th> : ""}
                  {kubun != 4 && kubun != 1 ? <td>
                    <TextField onChange={(e) => { setkingaku(e.target.value) }} style={{ width: 400 }} id="outlined-basic" variant="outlined" />
                  </td> : ""}
                  {kubun != 1 ? <th>定価</th> : ""}
                  {kubun != 1 ? <td>
                    <TextField onChange={(e) => { setteika(e.target.value) }} style={{ width: 400 }} id="outlined-basic" variant="outlined" />
                  </td> : ""}
                </tr> : ""}

              {loading == false ?
                <tr>
                  {kubun != 4 ? <th>コースNo.</th> : ""}
                  {kubun != 4 ? <td>
                    <TextField onChange={(e) => { setno(e.target.value) }} type="number" style={{ width: 400 }} id="outlined-basic" variant="outlined" />
                  </td> : ""}
                  {kubun == 1 ? <th>申込FormsのURL</th> : ""}
                  {kubun == 1 ? <td>
                    <TextField onChange={(e) => { setUrl(e.target.value) }}  style={{ width: 400 }} id="outlined-basic" variant="outlined" />
                  </td> : ""}
                  {kubun == 4 ? <th>本社貸出</th> : ""}
                  {kubun == 4 ? <td>
                    <FormControl component="fieldset" style={{ marginLeft: 30 }}>
                      <FormControlLabel
                        onChange={(e) => { check(e.target) }}
                        value="1"
                        control={<Checkbox />}
                        labelPlacement="end"
                        sx={{ mr: 7 }}
                      />
                    </FormControl>
                  </td> : ""}
                </tr> : ""}


              {loading == false ?
                kubun == 4 ? <tr>
                  <th>推薦図書画像</th>
                  <td>
                    {fileName ?
                      <div>{fileName}
                        <IconButton onClick={() => (setfileName(), setfile())}>
                          <HighlightOffIcon style={{ marginLeft: 10 }} />
                        </IconButton></div> :
                      <Dropzone
                        onDrop={onDrop}
                      >
                        {({ getRootProps, getInputProps }) => (
                          <div {...getRootProps({ className: 'dropzone' })} style={{ background: "#f5f5f5", height: 60, border: "solid" }}>
                            <input {...getInputProps()} />
                            <div>
                              <p>クリックまたはドラッグでファイルをアップロード</p>
                              <ul style={{ padding: 0, marginTop: 3 }}  >
                              </ul>
                            </div>
                          </div>
                        )}
                      </Dropzone>}
                  </td>
                </tr> : "" : ""}


            </tbody>
          </table>

          <div style={{ margin: "auto", width: "0", marginTop: 50 }}>
            <Button onClick={insertData} variant="contained" sx={{ backgroundColor: "rgb(92 184 92)", width: 100 }}>
              登録
            </Button>
          </div>
        </Box>
      </Box>
    </Modal>
  );
};

export default NewTrainingModal;
